import {
	Grid,
	Paper,
	Typography,
	Box,
	useTheme,
	Pagination,
	LinearProgress,
	Button,
	Stack,
	Drawer,
} from "@mui/material";
import useStyles from "./styles";

import { useEffect, useState } from "react";
import api from "../../../services/api";
// Importamos o useBlocker do react-router-dom
import { useOutletContext, useBlocker } from "react-router-dom";
import CardSelection, { getSafeTags } from "./cardSelection";
import PreviewData from "./previewData";
import ServerForm from "./editAccess";
import InformationMale from "../../../assets/imgs/persons/informationMale.png";
import InternoModalConfirmacaoSaida from "../../../components/modalSaindoDaPagina";

export default function Acessos() {
	const outletContext = useOutletContext();
	const [setSnackbar, clienteInfo] = outletContext;
	const { tagFilter, setTagFilter, tipoFilter, setTipoFilter, setTagOptions } =
		outletContext[12];
	const [allAcessos, setAllService] = useState([]);
	const [selectAcessos, setSelectService] = useState({});

	// Controle de Estados da Página
	const [editingItem, setEditingItem] = useState(null);
	const [selectCliente, setSelectCliente] = useState("");
	const [totalAccordions, setTotalAccordions] = useState();
	const [loading, setLoading] = useState(false);
	const [page, setPage] = useState(1);
	const [url, setUrl] = useState("");

	// Estados para controlar a visualização na direita
	const [editMode, setEditMode] = useState(false);
	const [isCreating, setIsCreating] = useState(false);

	const isFormActive = editMode || isCreating;

	// --- ESTADOS PARA O MODAL DE EXCLUSÃO ---
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [idToDelete, setIdToDelete] = useState(null);
	const [typeToDelete, setTypeToDelete] = useState(null);
	const [deleteLoad, setDeleteLoad] = useState(false);

	// --- ESTADOS PARA O MODAL DE SAÍDA DE EDIÇÃO ---
	const [openLeaveModal, setOpenLeaveModal] = useState(false);
	const [pendingAction, setPendingAction] = useState({ action: null });
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	// --- ESTADOS PARA O DRAWER DE MOBILE---
	const [openDrawer, setOpenDrawer] = useState(false);

	const theme = useTheme();
	const styles = useStyles(theme);
	const itemsPerPage = windowWidth > 2000 ? 9 : 6;

	const [currentType, setCurrentType] = useState(0);

	const { paginatedAcessos, totalPages } = getPaginatedAcessos({
		allAcessos,
		selectAcessos,
		tipoFilter,
		tagFilter,
		page,
		itemsPerPage,
	});

	const selectedItem = allAcessos?.find((item) => item?.id === selectCliente);

	useEffect(() => {
		const handleBeforeUnload = (e) => {
			if (isFormActive) {
				e.preventDefault();
				e.returnValue = "";
			}
		};

		window?.addEventListener("beforeunload", handleBeforeUnload);
		return () =>
			window?.removeEventListener("beforeunload", handleBeforeUnload);
	}, [isFormActive]);

	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
		};

		window.addEventListener("resize", handleResize);
	}, []);

	const blocker = useBlocker(
		({ currentLocation, nextLocation }) =>
			isFormActive && currentLocation?.pathname !== nextLocation?.pathname,
	);

	useEffect(() => {
		if (blocker?.state === "blocked") {
			setOpenLeaveModal(true);
		}
	}, [blocker?.state]);

	useEffect(() => {
		if (clienteInfo) {
			getAllAcessos(clienteInfo?.id);
		}
	}, [clienteInfo]);

	useEffect(() => {
		setPage(1);
		setSelectCliente("");
		setIsCreating(false);
	}, [selectAcessos]);

	useEffect(() => {
		setPage(1);
	}, [tipoFilter, tagFilter]);

	useEffect(() => {
		setTagOptions([
			...new Map(
				allAcessos.flatMap(getSafeTags).map((tag) => [tag?.id, tag]),
			).values(),
		]);
	}, [allAcessos]);

	function getPaginatedAcessos({
		allAcessos,
		selectAcessos,
		tipoFilter,
		tagFilter,
		page,
		itemsPerPage,
	}) {
		let filteredAcessos = allAcessos;
		if (selectAcessos && selectAcessos?.id) filteredAcessos = [selectAcessos];

		if (tipoFilter?.length > 0)
			filteredAcessos = filteredAcessos?.filter((acesso) =>
				tipoFilter.some((tipo) => tipo?.value === acesso?.tipo),
			);

		if (tagFilter?.length > 0)
			filteredAcessos = filteredAcessos?.filter((acesso) =>
				getSafeTags(acesso).some((tag) =>
					tagFilter.some((selected) => selected?.id === tag?.id),
				),
			);

		const startIndex = (page - 1) * itemsPerPage;
		const endIndex = startIndex + itemsPerPage;
		const paginatedAcessos = filteredAcessos?.slice(startIndex, endIndex);
		const totalPages = Math?.ceil(filteredAcessos?.length / itemsPerPage) || 1;
		return { paginatedAcessos, totalPages };
	}

	async function getAllAcessos(id) {
		setSelectService(null);
		setTipoFilter([]);
		setTagFilter([]);
		setPage(1);
		setLoading(true);

		try {
			let allVms = [];
			let allDatabases = [];
			let allWebAccess = [];
			let allVpns = [];

			if (
				clienteInfo?.isGrupoEconomico &&
				Array.isArray(clienteInfo?.membros) &&
				clienteInfo?.membros?.length > 0
			) {
				const responses = await Promise.all(
					clienteInfo.membros.map((membro) =>
						api.post("/getForms", { clienteId: membro.id }).catch(() => null),
					),
				);
				responses.forEach((res) => {
					if (res?.data) {
						const { vms, databases, webAccess, vpns } = res.data;
						if (vms) allVms.push(...vms);
						if (databases) allDatabases.push(...databases);
						if (webAccess) allWebAccess.push(...webAccess);
						if (vpns) allVpns.push(...vpns);
					}
				});
			} else {
				const response = await api?.post("/getForms", {
					clienteId: clienteInfo?.id,
				});
				const { vms, databases, webAccess, vpns } = response.data || {};
				if (vms) allVms.push(...vms);
				if (databases) allDatabases.push(...databases);
				if (webAccess) allWebAccess.push(...webAccess);
				if (vpns) allVpns.push(...vpns);
			}

			const listVMs = (allVms || [])?.map((item) => ({ ...item, tipo: 0 }));
			const listDBs = (allDatabases || [])?.map((item) => ({
				...item,
				tipo: 1,
			}));
			const listWeb = (allWebAccess || [])?.map((item) => ({
				...item,
				tipo: 2,
			}));
			const listVPN = (allVpns || [])?.map((item) => ({ ...item, tipo: 3 }));

			const allServices = [...listVMs, ...listDBs, ...listWeb, ...listVPN];
			allServices?.sort(
				(a, b) => new Date(b?.createAt) - new Date(a?.createAt),
			);

			setAllService(allServices);
			setTotalAccordions(allServices?.length);
		} catch (error) {
			console.error("Erro ao buscar acessos:", error);
			setAllService([]);
			setSnackbar({
				children: "Erro ao carregar lista de acessos.",
				severity: "error",
			});
		} finally {
			setLoading(false);
		}
	}

	const handleNavigationAttempt = (actionFn) => {
		if (isFormActive) {
			setPendingAction({ action: actionFn });
			setOpenLeaveModal(true);
		} else {
			actionFn();
		}
	};

	const confirmLeaveAction = () => {
		if (pendingAction?.action) {
			pendingAction?.action();
		}
		if (blocker?.state === "blocked") {
			blocker?.proceed();
		}

		setOpenLeaveModal(false);
		setPendingAction({ action: null });
		setEditMode(false);
		setIsCreating(false);
	};

	const cancelLeaveAction = () => {
		setOpenLeaveModal(false);
		setPendingAction({ action: null });
		// Informa ao React Router para cancelar a navegação e ficar na página
		if (blocker?.state === "blocked") {
			blocker?.reset();
		}
	};

	const handleChangePagination = (event, newPage) => {
		handleNavigationAttempt(() => {
			setPage(newPage);
			setSelectService(null);
		});
	};

	const handleOpenNew = () => {
		setSelectCliente("");
		setEditingItem(null);
		setEditMode(false);
		setIsCreating(true);
	};

	const handleOpenEdit = (item) => {
		setEditingItem(item);
	};

	const handleSaveAcesso = async (dadosDoModal) => {
		try {
			if (editingItem && !isCreating) {
				await api?.put("/updateForm", {
					...dadosDoModal,
					clienteId: clienteInfo?.id,
				});
				setSnackbar({
					children: "Acesso atualizado com sucesso!",
					severity: "success",
				});
			} else {
				await api?.post("/createForm", {
					...dadosDoModal,
					clienteId: clienteInfo?.id,
				});
				setSnackbar({
					children: "Novo acesso adicionado!",
					severity: "success",
				});
			}

			await getAllAcessos(clienteInfo?.id);
			setIsCreating(false);
			setEditMode(false);

			setOpenDrawer(false);
		} catch (error) {
			console.error("Erro ao salvar:", error);
			setSnackbar({
				children: error?.response?.data?.error || "Erro ao salvar o acesso.",
				severity: "error",
			});
		}
	};

	const handleDeleteAcesso = (id, tipo) => {
		setIdToDelete(id);
		setTypeToDelete(tipo);
		setOpenDeleteModal(true);
	};

	const confirmDeleteAction = async () => {
		if (!idToDelete) return;

		setDeleteLoad(true);
		try {
			await api?.post("/deleteForm", { id: idToDelete, tipo: typeToDelete });
			const novaLista = allAcessos.filter((item) => item?.id !== idToDelete);
			setAllService(novaLista);

			if (selectCliente === idToDelete) {
				setSelectCliente("");
				setIsCreating(false);
				setEditMode(false);
			}

			setTotalAccordions((prev) => prev - 1);
			setSnackbar({
				children: "Acesso removido com sucesso!",
				severity: "success",
			});
			setOpenDeleteModal(false);
		} catch (error) {
			console.error("Erro ao deletar acesso:", error);
			setSnackbar({ children: "Erro ao deletar acesso!", severity: "error" });
		} finally {
			setDeleteLoad(false);
			setIdToDelete(null);
			setTypeToDelete(null);
		}
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				gap: 2,
				position: "relative",
			}}
		>
			<Grid
				container
				spacing={1}
				columns={{ xs: 8, sm: 8, smx: 8, md: 12, lg: 12, xl: 12, xxl: 12 }}
			>
				{/* LADO ESQUERDO (Lista de Acessos) */}
				<Grid sx={styles.paperFluxo} item xs={8} sm={8} smx={8} md={4} lg={4}>
					<Paper
						elevation={theme.palette.mode === "dark" ? 0 : 3}
						sx={{
							...styles.paperFluxo,
							height: "83vh",
							overflowY: "auto",
							display: "flex",
							flexDirection: "column",
						}}
					>
						<Stack
							direction="row"
							justifyContent="space-between"
							alignItems="center"
							mb={2}
							p={1}
						>
							<Typography variant="mySubtitle">{`Acessos`}</Typography>
							<Button
								variant="outlined"
								size="small"
								onClick={() =>
									handleNavigationAttempt(() => {
										handleOpenNew();
										setOpenDrawer(true);
									})
								}
							>
								Novo Acesso
							</Button>
						</Stack>

						{loading && <LinearProgress sx={{ mb: 2 }} />}

						{paginatedAcessos?.length > 0 ? (
							<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
								{paginatedAcessos?.map((acesso, index) => {
									const isSelected = selectCliente === acesso?.id;
									return (
										<Box
											key={index}
											onClick={() => {
												handleNavigationAttempt(() => {
													setOpenDrawer(true);
													setSelectCliente(acesso.id);
													setIsCreating(false);
													setEditMode(false);
												});
											}}
											sx={{ cursor: "pointer" }}
										>
											<CardSelection
												title={acesso?.titulo}
												ip={acesso?.ip}
												idCliente={acesso?.id}
												status={acesso?.tipo}
												selected={isSelected}
												onDelete={() =>
													handleDeleteAcesso(acesso?.id, acesso?.tipo)
												}
												url={url}
												currentType={currentType}
												acesso={acesso}
												windowWidth={windowWidth}
											/>
										</Box>
									);
								})}
							</Box>
						) : (
							!loading && (
								<Box
									sx={{
										display: "flex",
										flexDirection: "column",
										justifyContent: "center",
										alignItems: "center",
										flex: 1,
										textAlign: "center",
										width: "100%",
										p: 2,
									}}
								>
									<Typography variant="mySubtitle">
										Nenhum acesso encontrado.
									</Typography>
									<Typography sx={{ fontSize: 18 }}>
										Você pode criar um novo acesso
									</Typography>
									<Typography sx={{ fontSize: 18, mb: 2 }}>
										clicando no botão{" "}
										<span
											style={{
												fontWeight: 700,
												color: theme.palette.primary.main,
											}}
										>
											"Novo Acesso"
										</span>{" "}
										acima.
									</Typography>
									<img
										src={InformationMale}
										alt="Information"
										style={{ maxWidth: "80%", height: "auto" }}
									/>
								</Box>
							)
						)}

						{totalPages > 1 && (
							<Box sx={{ ...styles.pagination, mt: 2 }}>
								<Pagination
									count={totalPages}
									page={page}
									onChange={handleChangePagination}
								/>
							</Box>
						)}
					</Paper>
				</Grid>

				{windowWidth >= 900 && (
					<Grid sx={styles.paperFluxo} item smx={5} md={8} lg={8}>
						<Paper
							sx={{
								...styles.paperFluxo,
								height: "83vh",
								pt: 0,
								position: "relative",
							}}
						>
							{selectedItem || isCreating ? (
								<Box sx={{ height: "100%", p: 2, overflowY: "auto" }}>
									{isFormActive ? (
										<ServerForm
											initialData={isCreating ? null : selectedItem}
											acesso={isCreating ? null : selectedItem}
											onSave={(dados) => handleSaveAcesso(dados)}
											onCancel={() => {
												setIsCreating(false);
												setEditMode(false);
											}}
											setUrl={setUrl}
											setCurrentType={setCurrentType}
										/>
									) : (
										<PreviewData
											acesso={selectedItem}
											tipo={selectedItem?.tipo}
											ip={selectedItem?.ip}
											sshPort={selectedItem?.sshPort}
											sshUser={selectedItem?.sshUser}
											sshPass={selectedItem?.sshPass}
											rootPass={selectedItem?.rootPass}
											setSnackbar={setSnackbar}
											onEdit={() => (
												setEditMode(true),
												handleOpenEdit(selectedItem)
											)}
										/>
									)}
								</Box>
							) : (
								<Box sx={styles.boxEmpty} />
							)}
						</Paper>
					</Grid>
				)}
			</Grid>

			{windowWidth < 900 && (
				<Drawer
					anchor="right"
					open={openDrawer}
					onClose={() => setOpenDrawer(false)}
					sx={{
						"& .MuiDrawer-paper": {
							width: "100%",
							maxWidth: "100%",
						},
					}}
				>
					<Paper
						sx={{
							...styles.paperFluxo,
							height: "83vh",
							pt: 0,
							position: "relative",
						}}
					>
						{selectedItem || isCreating ? (
							<Box sx={{ height: "100%", p: 2, overflowY: "auto" }}>
								{isFormActive ? (
									<ServerForm
										initialData={isCreating ? null : selectedItem}
										acesso={isCreating ? null : selectedItem}
										onSave={(dados) => handleSaveAcesso(dados)}
										onCancel={() => {
											setIsCreating(false);
											setEditMode(false);
										}}
										setUrl={setUrl}
										setCurrentType={setCurrentType}
										setOpenDrawer={setOpenDrawer}
										windowWidth={windowWidth}
									/>
								) : (
									<PreviewData
										acesso={selectedItem}
										tipo={selectedItem?.tipo}
										ip={selectedItem?.ip}
										sshPort={selectedItem?.sshPort}
										sshUser={selectedItem?.sshUser}
										sshPass={selectedItem?.sshPass}
										rootPass={selectedItem?.rootPass}
										setSnackbar={setSnackbar}
										onEdit={() => (
											setEditMode(true),
											handleOpenEdit(selectedItem)
										)}
										setOpenDrawer={setOpenDrawer}
										windowWidth={windowWidth}
									/>
								)}
							</Box>
						) : null}
					</Paper>
				</Drawer>
			)}

			{/* Modal de Exclusão */}
			<InternoModalConfirmacaoSaida
				openConfirmacao={openDeleteModal}
				setOpenConfirmacao={setOpenDeleteModal}
				confirmLoad={deleteLoad}
				execute={confirmDeleteAction}
				cancel={() => setIdToDelete(null)}
				title="Atenção"
				contentText="Tem certeza que deseja excluir este acesso? Essa ação é irreversível."
				confirmText="Excluir"
			/>

			{/* Modal de Saída de Edição/Criação */}
			<InternoModalConfirmacaoSaida
				openConfirmacao={openLeaveModal}
				setOpenConfirmacao={setOpenLeaveModal}
				confirmLoad={false}
				execute={confirmLeaveAction}
				cancel={cancelLeaveAction}
				title="Atenção"
				contentText="Tem certeza de que deseja sair? Todas as alterações não salvas serão perdidas."
				confirmText="Sair sem salvar"
				severity="warning"
			/>
		</Box>
	);
}
